import React, { useState } from 'react';
import './Styles.css';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import Modal from '../../../../../Elements/ids/Modal';
import RevokeConfirmationButtons from './Buttons/RevokeConfirmationButtons';
import { ServiceClient } from '../../../../../Services/ServiceClient';
import { deleteTeam, removeAgent, revokeAgent } from './Functions';
import Form from '../../../../../Elements/Form';
import { revokeConfirmationFormId, revokeResult } from './Enums';
import ErrorMessage from '../../../../../Elements/ErrorMessage';
import { createServerErrorMessage } from '../../../../../Helpers/FormInputHelper';
import { useNavigate } from 'react-router-dom';

const RevokeConfirmation = ({ agent, closeView, team, teamPageDispatch }) => {
  const [revokeState, setRevokeState] = useState(revokeResult.undefined);
  const [resultMessage, setResultMessage] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  /**
   * This makes the cancel button navigate back to search page, since the team has already been removed by API and there should not be any back or cancel button
   */
  const cancelFunction = () => {
    revokeState === revokeResult.removedWithTeam ? navigate('/') : closeView();
  };

  const onSubmit = (event, revokedAgent) => {
    event.preventDefault();

    ServiceClient.revokeAgentCode(
      revokedAgent.code,
      data => {
        if (data.result === revokeResult.revoked) {
          revokeAgent(
            team,
            { ...data.agent, address: revokedAgent.address, addressIsInherited: revokedAgent.addressIsInherited },
            teamPageDispatch
          );
          setResultMessage(
            formatMessage(Messages.revokeConfirmation_agentRevoked, {
              agentCode: revokedAgent.code,
            })
          );
        } else if (data.result === revokeResult.removed) {
          removeAgent(team, agent, teamPageDispatch);
          setResultMessage(
            formatMessage(Messages.revokeConfirmation_agentRemoved, {
              agentCode: revokedAgent.code,
            })
          );
        } else if (data.result === revokeResult.removedWithTeam) {
          deleteTeam(teamPageDispatch);
          setResultMessage(formatMessage(Messages.revokeConfirmation_teamDeleted));
        }
        setRevokeState(data.result);
      },
      error => {
        setError(createServerErrorMessage(error).message);
      }
    );
  };

  return (
    <Modal
      closeView={cancelFunction}
      titleText={formatMessage(Messages.revokeConfirmation_title)}
      buttons={<RevokeConfirmationButtons closeView={cancelFunction} revokeState={revokeState} error={error} />}>
      <Form
        formId={revokeConfirmationFormId}
        onSubmit={e => {
          onSubmit(e, agent);
        }}>
        <div className="teamPage-revokeConfirmation-container">
          <div className="common-table-row teamPage-revokeConfirmation-row headerRow">
            <div>{formatMessage(Messages.common_agentCode)}</div>
            <div>{formatMessage(Messages.common_costCenter)}</div>
            <div>{formatMessage(Messages.common_externalSalesCode)}</div>
            <div>{formatMessage(Messages.common_activationDate)}</div>
          </div>

          <div className="common-table-row teamPage-revokeConfirmation-row">
            <div>{agent.code}</div>
            <div>{`${agent.costCenter.name} (${agent.costCenter.code})`}</div>
            <div>{agent.externalSalesCode}</div>
            <div>{agent.validFrom}</div>
          </div>

          {resultMessage && <p>{resultMessage}</p>}
        </div>

        <ErrorMessage message={error} />
      </Form>
    </Modal>
  );
};

export default RevokeConfirmation;
